/* eslint-disable no-unused-vars */
import CandidateTimeEntries from './responses/candidateTimeEntires'

/**
 * @class
 */
export default class DisputeTimesheetDetailsTimeEntryCommentModel extends CandidateTimeEntries {
  constructor(params) {
    super(params)
    /** @type {string} */
    this.bookingStartTime = params.bookingStartTime
    /** @type {string} */
    this.bookingEndTime = params.bookingEndTime
    /** @type {number|null} */
    this.bookingMealBreakMinutes = params.bookingMealBreakMinutes
  }
}
